import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {ButtonModule} from "primeng/button";
import { SliderModule } from 'primeng/slider';
import {PessoaComponent} from "./pages/crud/pessoa/edit/pessoa.component";
import {ListPessoaComponent} from "./pages/crud/pessoa/list/list-pessoa.component";
import {Table, TableModule} from "primeng/table";
import {AnimateModule} from "primeng/animate";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {TranslateLoader, TranslateModule, TranslateService, TranslateStore} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {FormsModule} from "@angular/forms";
import {AuthHttpInterceptor, AuthModule} from "@auth0/auth0-angular";

import { domain, clientId, callbackUri } from './auth.config';
import {SQLiteService} from "./services/sqlite.service";
import {StorageService} from "./services/storage.service";
import {DbnameVersionService} from "./services/dbname-version.service";
import {Sincronizador} from "./services/sincronizacao/Sincronizador";
import {VersaoHttpService} from "./services/persist/http/VersaoHttpService";
import {BiomaHttpService} from "./services/persist/http/BiomaHttpService";
import {BiomaSQLService} from "./services/persist/sql/BiomaSQLService";
import {VersaoSQLService} from "./services/persist/sql/VersaoSQLService";
import {ProjetoHttpService} from "./services/persist/http/ProjetoHttpService";
import {ProjetoSQLService} from "./services/persist/sql/ProjetoSQLService";
import {LocalHttpService} from "./services/persist/http/LocalHttpService";
import {LocalSQLService} from "./services/persist/sql/LocalSQLService";
import {TipoMarcacaoHttpService} from "./services/persist/http/TipoMarcacaoHttpService";
import {TipoMarcacaoSQLService} from "./services/persist/sql/TipoMarcacaoSQLService";
import {ComportamentoHttpService} from "./services/persist/http/ComportamentoHttpService";
import {ComportamentoSQLService} from "./services/persist/sql/ComportamentoSQLService";
import {DrogaHttpService} from "./services/persist/http/DrogaHttpService";
import {DrogaSQLService} from "./services/persist/sql/DrogaSQLService";
import {UnidadeMedidaSQLService} from "./services/persist/sql/UnidadeMedidaSQLService";
import {UnidadeMedidaHttpService} from "./services/persist/http/UnidadeMedidaHttpService";
import {PessoaHttpService} from "./services/persist/http/PessoaHttpService";
import {PessoaSQLService} from "./services/persist/sql/PessoaSQLService";
import {TaxonSQLService} from "./services/persist/sql/TaxonSQLService";
import {TaxonHttpService} from "./services/persist/http/TaxonHttpService";
import {CommonModule} from "@angular/common";
import {MyAuthHttpInterceptor} from "./services/MyAuthHttpInterceptor";
import {MultiSelectModule} from "primeng/multiselect";
import {ConfirmationService, MessageService} from "primeng/api";
import {InputTextModule} from "primeng/inputtext";
import {ToastModule} from "primeng/toast";
import {RodapeComponent} from "./pages/crud/rodape/rodape.component";
import {HeaderComponent} from "./pages/crud/header/header.component";
import {ListLocalComponent} from "./pages/crud/local/list-local/list-local.component";
import {EditLocalComponent} from "./pages/crud/local/edit-local/edit-local.component";
import {TreeTableModule} from "primeng/treetable";
import {FolderPage} from "./folder/folder.page";
import {ListProjetoComponent} from "./pages/crud/projeto/list-projeto/list-projeto.component";
import {EditProjetoComponent} from "./pages/crud/projeto/edit-projeto/edit-projeto.component";
import {CalendarModule} from "primeng/calendar";
import {TreeSelectModule} from "primeng/treeselect";
import {SkeletonModule} from "primeng/skeleton";
import { ServiceWorkerModule } from '@angular/service-worker';
import {EditMetodosComponent} from "./pages/crud/projeto/edit-metodos/edit-metodos.component";
import {EditCampanhasComponent} from "./pages/crud/projeto/edit-campanhas/edit-campanhas.component";
import {SelecaoLocalComponent} from "./pages/crud/local/selecao-local/selecao-local.component";
import {EditArquivoComponent} from "./pages/crud/arquivo/edit-arquivos/edit-arquivo.component";
import {EditEspecimeComponent} from "./pages/crud/especime/edit/edit-especime.component";
import {GpsComponent} from "./pages/crud/gps/gps.component";
import {TaxonSearchComponent} from "./pages/crud/taxon/taxon-search.component";
import {FaunaDataSource} from "./services/persist/FaunaDataSource";
import {HttpRepository} from "./services/persist/HttpRepository";
import {IRepository} from "./services/persist/IRepository";
import {EditMeteorologiaComponent} from "./pages/crud/especime/edit-meteorologia/edit-meteorologia.component";
import {HeaderListComponent} from "./pages/crud/header-list/header-list.component";
import {JornadaComponent} from "./pages/crud/jornada/edit/jornada.component";
import {ListMonitoramentoComponent} from "./pages/crud/monitoramento/list/list-monitoramento.component";
import {EditMonitoramentoComponent} from "./pages/crud/monitoramento/edit/edit-monitoramento.component";
import {RippleModule} from "primeng/ripple";
import {GpsService} from "./services/gps.service";
import {ShareService} from "./services/ShareService";
import {TrackingComponent} from "./pages/tracking/tracking.component";
import {BadgeModule} from "primeng/badge";
import {ListEspecimeComponent} from "./pages/crud/especime/list-especime/list-especime.component";
import {DashboardComponent} from "./pages/dashboard/dashboard.component";
import {SincronizacaoComponent} from "./pages/sincronizacao/sincronizacao.component";
import {UploadProjeto} from "./services/sincronizacao/upload/UploadProjeto";
import {UploadPessoa} from "./services/sincronizacao/upload/UploadPessoa";
import {UploadLocal} from "./services/sincronizacao/upload/UploadLocal";
import {UploadEspecime} from "./services/sincronizacao/upload/UploadEspecime";
import {EspecimeHttpService} from "./services/persist/http/EspecimeHttpService";
import {MonitoramentoHttpService} from "./services/persist/http/MonitoramentoHttpService";
import {UploadMonitoramento} from "./services/sincronizacao/upload/UploadMonitoramento";
import {UploadJornada} from "./services/sincronizacao/upload/UploadJornada";
import {JornadaHttpService} from "./services/persist/http/JornadaHttpService";
import {ArquivoHttpService} from "./services/persist/http/ArquivoHttpService";
import {UploadArquivo} from "./services/sincronizacao/upload/UploadArquivo";
import {PopoverComponent} from "./pages/crud/jornada/popover/popoper.component";

@NgModule({
    declarations: [
      PopoverComponent,
        AppComponent, PessoaComponent, ListPessoaComponent, RodapeComponent, ListEspecimeComponent, EditEspecimeComponent,
        EditLocalComponent, FolderPage, ListProjetoComponent, EditProjetoComponent, EditMeteorologiaComponent,DashboardComponent,
        JornadaComponent, ListMonitoramentoComponent, EditMonitoramentoComponent,TrackingComponent,SincronizacaoComponent,
        HeaderComponent, ListLocalComponent, EditMetodosComponent, EditCampanhasComponent, SelecaoLocalComponent, EditArquivoComponent, GpsComponent, TaxonSearchComponent, EditMeteorologiaComponent, HeaderListComponent],
    imports: [BrowserModule, ButtonModule, TableModule, CommonModule,
        AuthModule.forRoot({
            domain,
            clientId,
            authorizationParams: {
                redirect_uri: callbackUri,
            },
            useRefreshTokens: true,
            useRefreshTokensFallback: false,
        }),

        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }), AnimateModule, FormsModule, HttpClientModule, BrowserAnimationsModule, SliderModule,
        IonicModule.forRoot(), FormsModule,
        AppRoutingModule, MultiSelectModule, InputTextModule, ToastModule, TreeTableModule, CalendarModule, TreeSelectModule, SkeletonModule, ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }), RippleModule, BadgeModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {provide: HTTP_INTERCEPTORS, useClass: MyAuthHttpInterceptor, multi: true},
    {
      provide: APP_INITIALIZER,
      useFactory: initializeBDFactory,
      deps: [SQLiteService, GpsService],
      multi: true
    },
    Sincronizador, VersaoHttpService, BiomaHttpService,BiomaSQLService,
    UploadProjeto,UploadPessoa,UploadLocal,UploadEspecime,UploadMonitoramento,UploadJornada,UploadArquivo,
    ProjetoHttpService,ProjetoSQLService,LocalSQLService,FaunaDataSource,
    EspecimeHttpService,MonitoramentoHttpService,JornadaHttpService,ArquivoHttpService,
    ComportamentoSQLService, MessageService, ConfirmationService,PessoaHttpService, PessoaSQLService, TaxonSQLService, TaxonHttpService,
    DrogaHttpService,DrogaSQLService, UnidadeMedidaSQLService, UnidadeMedidaHttpService,HttpRepository,
    LocalHttpService,TipoMarcacaoHttpService,TipoMarcacaoSQLService,ComportamentoHttpService,
     SQLiteService, StorageService, DbnameVersionService, VersaoSQLService,ShareService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function initializeBDFactory(init: SQLiteService, gps: GpsService) {
  return async () => {
    const  resp = await init.initialize();
    gps.continuar()
    return resp
  }
}


